<div class="modal approval-modal">
  <div class="modal_head">
    <h2>{{ 'DriverApproval' | translate }}</h2>
  </div>
  <div class="modal_body">
    <form [formGroup]="approvalForm" (ngSubmit)="onSubmit()">
      <div class="input_groups">
        <!-- Driver Profile Section -->
        <div class="driver-profile" *ngIf="driverInfo">
          <div class="profile-header">
            <div class="profile-image">
              <img [src]="driverInfo.image || 'assets/images/default-user.png'" alt="Driver Profile">
            </div>
            <div class="profile-info">
              <h3>{{ driverInfo.name }}</h3>
              <p><i class="material-icons">{{ 'Email' | translate }}</i> {{ driverInfo.email }}</p>
              <p><i class="material-icons">phone</i> {{ driverInfo.dialCode }}{{ driverInfo.phoneNo }}</p>
              <p *ngIf="driverInfo.vehicleNumber"><i class="material-icons">directions_car</i> {{ driverInfo.vehicleNumber }}</p>
            </div>
          </div>
        </div>

        <div class="section-divider">
          <span>{{ 'AssignmentDetails' | translate }}</span>
        </div>

        <!-- Geofence Selection-->
        <div class="form_group">
          <mat-label class="required">{{ 'Geofence' | translate }}</mat-label>
          <mat-form-field>
            <mat-select
              placeholder="{{ 'SelectGeofence' | translate }}"
              formControlName="geofenceId" class="form_control">
              <mat-option
                [value]="item._id"
                *ngFor="let item of geofenceList"
                (click)="onGeofenceSelect(item._id || '')">
                <span class="option-content">
                  <!-- <i class="material-icons">place</i> -->
                  {{ item.name }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              approvalForm.controls['geofenceId'].hasError('required')
            ">
            {{ 'Geofence' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
        </div>
        <!-- Team Selection -->
        <div class="form_group">
          <mat-label class="required">{{ 'Team' | translate }}</mat-label>
          <mat-form-field> 
            <mat-select
              placeholder="{{ 'SelectTeam' | translate }}"
              formControlName="teamId" class="form_control"
              [disabled]="!teamList || teamList.length === 0">
              <mat-option [value]="team._id" *ngFor="let team of teamList">
                <span class="option-content">
                  <!-- <i class="material-icons">group</i> -->
                  {{ team.teamName }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              approvalForm.controls['teamId'].hasError('required')
            ">
            {{ 'Team' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
          <div class="note-box" *ngIf="approvalForm.get('geofenceId')?.value && teamList && teamList.length === 0">
            <i class="material-icons">info</i>
            <span>{{ 'NoTeamsAvailableForGeofence' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="submit_btn">
        <button type="button" class="btnn btn_secondary" (click)="onCancel()">
          {{ 'Cancel' | translate }}
        </button>
        <button type="submit" class="btnn btn_primary">
          <i class="material-icons">check_circle</i>
          {{ 'ApproveDriver' | translate }}
        </button>
      </div>
    </form>
  </div>
</div> 